{
    "pl": {
        "Yes": "Tak",
        "No": "Nie",
        "Cancel": "Anuluj",
        "Close": "Zamknij",
        "Clear": "Usuń",
        "Done": "Gotowe",
        "Loading": "Ładowanie...",
        "Select": "Wybierz...",
        "Search": "Szukaj...",
        "Back": "Wróć...",
        "OK": "OK",

        "dxCollectionWidget-noDataText": "Brak dostępnych danych",

        "dxDropDownEditor-selectLabel": "Wybierz",

        "validation-required": "Pole obowiązkowe",
        "validation-required-formatted": "{0} jest polem obowiązkowym",
        "validation-numeric": "Wartość musi być liczbą",
        "validation-numeric-formatted": "{0} musi być liczbą",
        "validation-range": "Wartość nie mieści się w prawidłowym zakresie",
        "validation-range-formatted": "{0} nie mieści się w prawidłowym zakresie",
        "validation-stringLength": "Długość wartości nie jest poprawna",
        "validation-stringLength-formatted": "Długość {0} nie jest poprawna",
        "validation-custom": "Wartość jest nieprawidłowa",
        "validation-custom-formatted": "{0} jest nieprawidłowa",
        "validation-async": "Wartość jest nieprawidłowa",
        "validation-async-formatted": "{0} jest nieprawidłowa",
        "validation-compare": "Wartość jest nieodpowiednia",
        "validation-compare-formatted": "{0} jest nieodpowiednia",
        "validation-pattern": "Wartość nie pasuje do wzorca",
        "validation-pattern-formatted": "{0} nie pasuje do wzorca",
        "validation-email": "Adres e-mail jest nieprawidłowy",
        "validation-email-formatted": "{0} jest nieprawidłowa",
        "validation-mask": "Wartość jest nieprawidłowa",

        "dxLookup-searchPlaceholder": "Długość minimalna {0} znaków",

        "dxList-pullingDownText": "Aby zaktualizować, przeciągnij w dół",
        "dxList-pulledDownText": "Aby zaktualizować puść",
        "dxList-refreshingText": "Zaktualiz...",
        "dxList-pageLoadingText": "Ładowanie...",
        "dxList-nextButtonText": "Więcej",
        "dxList-selectAll": "Wybierz wszystko",
        "dxList-listAriaLabel": "Items",
        "dxList-listAriaLabel-deletable": "Deletable items",
        "dxListEditDecorator-delete": "Usuń",
        "dxListEditDecorator-more": "Więcej",

        "dxScrollView-pullingDownText": "Aby zaktualizować, przeciągnij w dół",
        "dxScrollView-pulledDownText": "Aby zaktualizować puść",
        "dxScrollView-refreshingText": "Zaktualiz...",
        "dxScrollView-reachBottomText": "Ładowanie...",

        "dxDateBox-simulatedDataPickerTitleTime": "Wybierz godzinę",
        "dxDateBox-simulatedDataPickerTitleDate": "Wybierz datę",
        "dxDateBox-simulatedDataPickerTitleDateTime": "Wybierz datę i godzinę",
        "dxDateBox-validation-datetime": "Wartość musi być datą lub godziną",

        "dxDateRangeBox-invalidStartDateMessage": "Start value must be a date",
        "dxDateRangeBox-invalidEndDateMessage": "End value must be a date",
        "dxDateRangeBox-startDateOutOfRangeMessage": "Start date is out of range",
        "dxDateRangeBox-endDateOutOfRangeMessage": "End date is out of range",
        "dxDateRangeBox-startDateLabel": "Start Date",
        "dxDateRangeBox-endDateLabel": "End Date",

        "dxFileUploader-selectFile": "Wybierz plik",
        "dxFileUploader-dropFile": "lub przeciągnij tutaj",
        "dxFileUploader-bytes": "Bajty",
        "dxFileUploader-kb": "KB",
        "dxFileUploader-Mb": "MB",
        "dxFileUploader-Gb": "GB",
        "dxFileUploader-upload": "Załaduj",
        "dxFileUploader-uploaded": "Załadowano",
        "dxFileUploader-readyToUpload": "Gotowy do załadowania",
        "dxFileUploader-uploadAbortedMessage": "Ładowanie anulowane",
        "dxFileUploader-uploadFailedMessage": "Błąd podczas ładowania",
        "dxFileUploader-invalidFileExtension": "Niedozwolony typ pliku",
        "dxFileUploader-invalidMaxFileSize": "Plik jest zbyt duży",
        "dxFileUploader-invalidMinFileSize": "Plik jest zbyt mały",

        "dxRangeSlider-ariaFrom": "Od",
        "dxRangeSlider-ariaTill": "Do",
        "dxSwitch-switchedOnText": "WŁ",
        "dxSwitch-switchedOffText": "WYŁ",

        "dxForm-optionalMark": "opcjonalnie",
        "dxForm-requiredMessage": "{0} jest polem obowiązkowym",

        "dxNumberBox-invalidValueMessage": "Wartość musi być liczbą",
        "dxNumberBox-noDataText": "Brak danych",

        "dxDataGrid-emptyHeaderWithColumnChooserText": "Use {0} to display columns",
        "dxDataGrid-emptyHeaderWithGroupPanelText": "Drag a column from the group panel here",
        "dxDataGrid-emptyHeaderWithColumnChooserAndGroupPanelText": "Use {0} or drag a column from the group panel",
        "dxDataGrid-emptyHeaderColumnChooserText": "column chooser",
        "dxDataGrid-columnChooserTitle": "Wybór kolumny",
        "dxDataGrid-columnChooserEmptyText": "Przeciągnij kolumny tutaj, aby je ukryć",
        "dxDataGrid-groupContinuesMessage": "Kontynuacja na następnej stronie",
        "dxDataGrid-groupContinuedMessage": "Kontynuacja z poprzedniej strony",
        "dxDataGrid-groupHeaderText": "Grupuj według tej kolumny",
        "dxDataGrid-ungroupHeaderText": "Usuń grupowanie",
        "dxDataGrid-ungroupAllText": "Usuń wszystkie grupowania",
        "dxDataGrid-editingEditRow": "Edytuj",
        "dxDataGrid-editingSaveRowChanges": "Zapisz",
        "dxDataGrid-editingCancelRowChanges": "Anuluj",
        "dxDataGrid-editingDeleteRow": "Usuń",
        "dxDataGrid-editingUndeleteRow": "Przywróć",
        "dxDataGrid-editingConfirmDeleteMessage": "Czy na pewno chcesz usunąć ten rekord?",
        "dxDataGrid-validationCancelChanges": "Anuluj zmiany",
        "dxDataGrid-groupPanelEmptyText": "Przeciągnij kolumnę tutaj, aby pogrupować według niej",
        "dxDataGrid-noDataText": "Brak danych",
        "dxDataGrid-searchPanelPlaceholder": "Szukaj...",
        "dxDataGrid-filterRowShowAllText": "(Wszystkie)",
        "dxDataGrid-filterRowResetOperationText": "Resetuj",
        "dxDataGrid-filterRowOperationEquals": "Jest równe",
        "dxDataGrid-filterRowOperationNotEquals": "Nie jest równe",
        "dxDataGrid-filterRowOperationLess": "Mniejsze niż",
        "dxDataGrid-filterRowOperationLessOrEquals": "Mniejsze lub równe",
        "dxDataGrid-filterRowOperationGreater": "Większe niż",
        "dxDataGrid-filterRowOperationGreaterOrEquals": "Większe lub równe",
        "dxDataGrid-filterRowOperationStartsWith": "Zaczyna się od",
        "dxDataGrid-filterRowOperationContains": "Zawiera",
        "dxDataGrid-filterRowOperationNotContains": "Nie zawiera",
        "dxDataGrid-filterRowOperationEndsWith": "Kończy się z",
        "dxDataGrid-filterRowOperationBetween": "Pomiędzy",
        "dxDataGrid-filterRowOperationBetweenStartText": "Początek",
        "dxDataGrid-filterRowOperationBetweenEndText": "Koniec",
        "dxDataGrid-ariaSearchBox": "Search box",
        "dxDataGrid-applyFilterText": "Stosuj filtry",
        "dxDataGrid-trueText": "prawda",
        "dxDataGrid-falseText": "fałsz",
        "dxDataGrid-sortingAscendingText": "Sortuj rosnąco",
        "dxDataGrid-sortingDescendingText": "Sortuj malejąco",
        "dxDataGrid-sortingClearText": "Resetuj sortowanie",
        "dxDataGrid-ariaNotSortedColumn": "Not sorted column",
        "dxDataGrid-ariaSortedAscendingColumn": "Column sorted in ascending order",
        "dxDataGrid-ariaSortedDescendingColumn": "Column sorted in descending order",
        "dxDataGrid-ariaSortIndex": "Sort index {0}",
        "dxDataGrid-editingSaveAllChanges": "Zapisz zmiany",
        "dxDataGrid-editingCancelAllChanges": "Anuluj zmiany",
        "dxDataGrid-editingAddRow": "Nowy wiersz",
        "dxDataGrid-summaryMin": "Min: {0}",
        "dxDataGrid-summaryMinOtherColumn": "Minimum {1} wynosi {0}",
        "dxDataGrid-summaryMax": "Maks: {0}",
        "dxDataGrid-summaryMaxOtherColumn": "Maksimum {1} wynosi {0}",
        "dxDataGrid-summaryAvg": "Ø: {0}",
        "dxDataGrid-summaryAvgOtherColumn": "Średnia {1} wynosi {0}",
        "dxDataGrid-summarySum": "Suma: {0}",
        "dxDataGrid-summarySumOtherColumn": "Suma {1} wynosi {0}",
        "dxDataGrid-summaryCount": "Liczba: {0}",
        "dxDataGrid-columnFixingFix": "Ustal",
        "dxDataGrid-columnFixingUnfix": "Rozwiąż",
        "dxDataGrid-columnFixingLeftPosition": "Na lewo",
        "dxDataGrid-columnFixingRightPosition": "Na prawo",
        "dxDataGrid-exportTo": "Eksportuj",
        "dxDataGrid-exportToExcel": "Eksportuj jako plik excel",
        "dxDataGrid-exporting": "Eksport...",
        "dxDataGrid-excelFormat": "Plik excel",
        "dxDataGrid-selectedRows": "Wybrane wiersze",
        "dxDataGrid-exportSelectedRows": "Eksportuj wybrane wiersze do {0}",
        "dxDataGrid-exportAll": "Wszystkie dane eksportuj do {0}",
        "dxDataGrid-headerFilterLabel": "Opcje filtra",
        "dxDataGrid-headerFilterIndicatorLabel": "Wyświetl opcje filtra dla kolumny '{0}'",
        "dxDataGrid-headerFilterEmptyValue": "(Wartości puste)",
        "dxDataGrid-headerFilterOK": "OK",
        "dxDataGrid-headerFilterCancel": "Anuluj",
        "dxDataGrid-ariaAdaptiveCollapse": "Ukryj dodatkowe kolumny",
        "dxDataGrid-ariaAdaptiveExpand": "Wyświetl dodatkowe kolumny",
        "dxDataGrid-ariaColumn": "Kolumna",
        "dxDataGrid-ariaColumnHeader": "Column header",
        "dxDataGrid-ariaValue": "Wartość",
        "dxDataGrid-ariaError": "Error",
        "dxDataGrid-ariaRevertButton": "Press Escape to discard the changes",
        "dxDataGrid-ariaFilterCell": "Komórka filtra",
        "dxDataGrid-ariaCollapse": "Zwiń",
        "dxDataGrid-ariaModifiedCell": "Modified",
        "dxDataGrid-ariaDeletedCell": "Deleted",
        "dxDataGrid-ariaEditableCell": "Editable",
        "dxDataGrid-ariaExpand": "Rozwiń",
        "dxDataGrid-ariaCollapsedRow": "Collapsed row",
        "dxDataGrid-ariaExpandedRow": "Expanded row",
        "dxDataGrid-ariaDataGrid": "Tabela danych zawierająca {0} wiersze/-y i {1} kolumn/y",
        "dxDataGrid-ariaSearchInGrid": "Szukaj w tabeli danych",
        "dxDataGrid-ariaSelectAll": "Wybierz wszystkie",
        "dxDataGrid-ariaSelectRow": "Wybierz wiersz",
        "dxDataGrid-ariaToolbar": "Pasek narzędzi tabeli danych",
        "dxDataGrid-ariaEditForm": "Edit form",
        "dxDataGrid-filterBuilderPopupTitle": "Generator filtrów",
        "dxDataGrid-filterPanelCreateFilter": "Utwórz filtr",
        "dxDataGrid-filterPanelClearFilter": "Resetuj",
        "dxDataGrid-filterPanelFilterEnabledHint": "Aktywuj filtr",
        "dxDataGrid-masterDetail": "Cell with details",

        "dxTreeList-ariaTreeList": "Lista strukturalna",
        "dxTreeList-ariaSearchInGrid": "Szukaj w liście strukturalnej",
        "dxTreeList-ariaToolbar": "Pasek narzędzi listy strukturalnej",
        "dxTreeList-editingAddRowToNode": "Dodaj",

        "dxPager-infoText": "Strona {0} z {1} ({2} elementy)",
        "dxPager-pagesCountText": "od",
        "dxPager-pageSize": "Elementy na stronie: {0}",
        "dxPager-pageSizesAllText": "Wszystkie/wszyscy",
        "dxPager-page": "Strona {0}",
        "dxPager-prevPage": "Poprzednia strona",
        "dxPager-nextPage": "Następna strona",
        "dxPager-ariaLabel": "Nawigacja strony",
        "dxPager-ariaPageSize": "Page size",
        "dxPager-ariaPageNumber": "Page number",

        "dxPivotGrid-grandTotal": "Łącznie",
        "dxPivotGrid-total": "{0} Łącznie",
        "dxPivotGrid-fieldChooserTitle": "Wybór pola",
        "dxPivotGrid-showFieldChooser": "Wyświetl wybór pola",
        "dxPivotGrid-expandAll": "Rozwiń wszystkie",
        "dxPivotGrid-collapseAll": "Zwiń wszystkie",
        "dxPivotGrid-sortColumnBySummary": "\"{0}\" sortuj według tej kolumny",
        "dxPivotGrid-sortRowBySummary": "\"{0}\" sortuj według tego wiersza",
        "dxPivotGrid-removeAllSorting": "Anuluj sortowanie",
        "dxPivotGrid-dataNotAvailable": "Usuń",
        "dxPivotGrid-rowFields": "Pola wierszy",
        "dxPivotGrid-columnFields": "Pola kolumn",
        "dxPivotGrid-dataFields": "Pola danych",
        "dxPivotGrid-filterFields": "Pole filtra",
        "dxPivotGrid-allFields": "Wszystkie pola",
        "dxPivotGrid-columnFieldArea": "Przeciągnij pola kolumn/y tutaj",
        "dxPivotGrid-dataFieldArea": "Przeciągnij pola danych tutaj",
        "dxPivotGrid-rowFieldArea": "Przeciągnij pola wiersza/-y tutaj",
        "dxPivotGrid-filterFieldArea": "Przeciągnij pola filtra tutaj",

        "dxScheduler-editorLabelTitle": "Dotyczy",
        "dxScheduler-editorLabelStartDate": "Czas rozpoczęcia",
        "dxScheduler-editorLabelEndDate": "Czas zakończenia",
        "dxScheduler-editorLabelDescription": "Opis",
        "dxScheduler-editorLabelRecurrence": "Powtórz",

        "dxScheduler-openAppointment": "Otwórz termin",

        "dxScheduler-recurrenceNever": "Nigdy",
        "dxScheduler-recurrenceMinutely": "minutowy",
        "dxScheduler-recurrenceHourly": "godzinowy",
        "dxScheduler-recurrenceDaily": "dzienny",
        "dxScheduler-recurrenceWeekly": "tygodniowy",
        "dxScheduler-recurrenceMonthly": "miesięczny",
        "dxScheduler-recurrenceYearly": "roczny",

        "dxScheduler-recurrenceRepeatEvery": "Powtórz wszystkie",
        "dxScheduler-recurrenceRepeatOn": "Powtórzyć dn.",
        "dxScheduler-recurrenceEnd": "Koniec powtórzenia",
        "dxScheduler-recurrenceAfter": "Do",
        "dxScheduler-recurrenceOn": "Dnia",

        "dxScheduler-recurrenceRepeatMinutely": "Minuta(-y)",
        "dxScheduler-recurrenceRepeatHourly": "Godzina(-y)",
        "dxScheduler-recurrenceRepeatDaily": "Dzień (dni)",
        "dxScheduler-recurrenceRepeatWeekly": "Tydzień (tygodnie)",
        "dxScheduler-recurrenceRepeatMonthly": "Miesiąc(-e)",
        "dxScheduler-recurrenceRepeatYearly": "Rok (lata)",

        "dxScheduler-switcherDay": "Dzień",
        "dxScheduler-switcherWeek": "Tydzień",
        "dxScheduler-switcherWorkWeek": "Tydzień roboczy",
        "dxScheduler-switcherMonth": "Miesiąc",

        "dxScheduler-switcherAgenda": "Agenda",

        "dxScheduler-switcherTimelineDay": "Dzień na osi czasu",
        "dxScheduler-switcherTimelineWeek": "Tydzień na osi czasu",
        "dxScheduler-switcherTimelineWorkWeek": "Tydzień roboczy na osi czasu",
        "dxScheduler-switcherTimelineMonth": "Miesiąc na osi czasu",

        "dxScheduler-recurrenceRepeatOnDate": "dnia",
        "dxScheduler-recurrenceRepeatCount": "Wydarzenia",
        "dxScheduler-allDay": "całodniowe",

        "dxScheduler-confirmRecurrenceEditTitle": "Edit Recurring Appointment",
        "dxScheduler-confirmRecurrenceDeleteTitle": "Delete Recurring Appointment",

        "dxScheduler-confirmRecurrenceEditMessage": "Czy chcesz edytować tylko ten termin, czy całą serię?",
        "dxScheduler-confirmRecurrenceDeleteMessage": "Czy chcesz usunąć tylko ten termin, czy całą serię?",

        "dxScheduler-confirmRecurrenceEditSeries": "Edytuj serię",
        "dxScheduler-confirmRecurrenceDeleteSeries": "Usuń serię",
        "dxScheduler-confirmRecurrenceEditOccurrence": "Edytuj termin",
        "dxScheduler-confirmRecurrenceDeleteOccurrence": "Usuń termin",

        "dxScheduler-noTimezoneTitle": "Brak strefy czasowej",
        "dxScheduler-moreAppointments": "{0} kolejne",

        "dxCalendar-currentDay": "Today",
        "dxCalendar-currentMonth": "Current month",
        "dxCalendar-currentYear": "Current year",
        "dxCalendar-currentYearRange": "Current year range",
        "dxCalendar-todayButtonText": "Dzisiaj",
        "dxCalendar-ariaWidgetName": "Kalendarz",
        "dxCalendar-previousMonthButtonLabel": "Previous month",
        "dxCalendar-previousYearButtonLabel": "Previous year",
        "dxCalendar-previousDecadeButtonLabel": "Previous decade",
        "dxCalendar-previousCenturyButtonLabel": "Previous century",
        "dxCalendar-nextMonthButtonLabel": "Next month",
        "dxCalendar-nextYearButtonLabel": "Next year",
        "dxCalendar-nextDecadeButtonLabel": "Next decade",
        "dxCalendar-nextCenturyButtonLabel": "Next century",
        "dxCalendar-captionMonthLabel": "Month selection",
        "dxCalendar-captionYearLabel": "Year selection",
        "dxCalendar-captionDecadeLabel": "Decade selection",
        "dxCalendar-captionCenturyLabel": "Century selection",
        "dxCalendar-selectedDate": "The selected date is {0}",
        "dxCalendar-selectedDateRange": "The selected date range is from {0} to {1}",

        "dxColorView-ariaRed": "czerwony",
        "dxColorView-ariaGreen": "zielony",
        "dxColorView-ariaBlue": "niebieski",
        "dxColorView-ariaAlpha": "transparentny",
        "dxColorView-ariaHex": "Wartość koloru",

        "dxTagBox-selected": "{0} wybrano",
        "dxTagBox-allSelected": "Wybrano wszystkie ({0})",
        "dxTagBox-moreSelected": "{0} kolejne",
        "dxTagBox-tagRoleDescription": "Tag. Press the delete button to remove this tag",

        "vizExport-printingButtonText": "Drukuj",
        "vizExport-titleMenuText": "Eksport/druk",
        "vizExport-exportButtonText": "Plik {0}",

        "dxFilterBuilder-and": "i",
        "dxFilterBuilder-or": "lub",
        "dxFilterBuilder-notAnd": "Nie i",
        "dxFilterBuilder-notOr": "Nie lub",
        "dxFilterBuilder-addCondition": "Dodaj warunek",
        "dxFilterBuilder-addGroup": "Dodaj grupę",
        "dxFilterBuilder-enterValueText": "<Podaj wartość>",
        "dxFilterBuilder-filterOperationEquals": "Jest równe",
        "dxFilterBuilder-filterOperationNotEquals": "Nie jest równe",
        "dxFilterBuilder-filterOperationLess": "Mniejsze niż",
        "dxFilterBuilder-filterOperationLessOrEquals": "Mniejsze lub równe",
        "dxFilterBuilder-filterOperationGreater": "Większe niż",
        "dxFilterBuilder-filterOperationGreaterOrEquals": "Większe lub równe",
        "dxFilterBuilder-filterOperationStartsWith": "Zaczyna się od",
        "dxFilterBuilder-filterOperationContains": "Zawiera",
        "dxFilterBuilder-filterOperationNotContains": "Nie zawiera",
        "dxFilterBuilder-filterOperationEndsWith": "Kończy się z",
        "dxFilterBuilder-filterOperationIsBlank": "Jest pusty",
        "dxFilterBuilder-filterOperationIsNotBlank": "Nie jest pusty",
        "dxFilterBuilder-filterOperationBetween": "Pomiędzy",
        "dxFilterBuilder-filterOperationAnyOf": "Jest zawarty w",
        "dxFilterBuilder-filterOperationNoneOf": "Nie jest zawarty w",

        "dxHtmlEditor-dialogColorCaption": "Zmień kolor czcionki",
        "dxHtmlEditor-dialogBackgroundCaption": "Zmień kolor tła",
        "dxHtmlEditor-dialogLinkCaption": "Dodaj link",
        "dxHtmlEditor-dialogLinkUrlField": "URL",
        "dxHtmlEditor-dialogLinkTextField": "Tekst",
        "dxHtmlEditor-dialogLinkTargetField": "Otwórz link w nowym oknie",
        "dxHtmlEditor-dialogImageCaption": "Dodaj obraz",
        "dxHtmlEditor-dialogImageUrlField": "URL",
        "dxHtmlEditor-dialogImageAltField": "Tekst alternatywny",
        "dxHtmlEditor-dialogImageWidthField": "Szerokość (px)",
        "dxHtmlEditor-dialogImageHeightField": "Wysokość obrazu (px)",
        "dxHtmlEditor-dialogInsertTableRowsField": "Wiersze",
        "dxHtmlEditor-dialogInsertTableColumnsField": "Kolumny",
        "dxHtmlEditor-dialogInsertTableCaption": "Wstaw tabelę",
        "dxHtmlEditor-dialogUpdateImageCaption": "Aktualizuj obraz",
        "dxHtmlEditor-dialogImageUpdateButton": "Aktualizuj",
        "dxHtmlEditor-dialogImageAddButton": "Dodaj",
        "dxHtmlEditor-dialogImageSpecifyUrl": "Z sieci",
        "dxHtmlEditor-dialogImageSelectFile": "Z tego urządzenia",
        "dxHtmlEditor-dialogImageKeepAspectRatio": "Zachowaj proporcje stron",
        "dxHtmlEditor-dialogImageEncodeToBase64": "Zakoduj jako Base64",
        "dxHtmlEditor-heading": "Nagłówek",
        "dxHtmlEditor-normalText": "Zwykły tekst",
        "dxHtmlEditor-background": "Kolor tła",
        "dxHtmlEditor-bold": "Wytłuszczenie",
        "dxHtmlEditor-color": "Kolor czcionki",
        "dxHtmlEditor-font": "Rodzaj czcionki",
        "dxHtmlEditor-italic": "Kurysywa",
        "dxHtmlEditor-link": "Dodaj link",
        "dxHtmlEditor-image": "Dodaj obraz",
        "dxHtmlEditor-size": "Rozmiar czcionki",
        "dxHtmlEditor-strike": "Przekreślenie",
        "dxHtmlEditor-subscript": "Indeks dolny",
        "dxHtmlEditor-superscript": "Indeks górny",
        "dxHtmlEditor-underline": "Podkreślenie",
        "dxHtmlEditor-blockquote": "Cytat blokowy",
        "dxHtmlEditor-header": "Wiersz nagłówka",
        "dxHtmlEditor-increaseIndent": "Zwiększ wcięcie",
        "dxHtmlEditor-decreaseIndent": "Zmniejsz wcięcie",
        "dxHtmlEditor-orderedList": "Lista posortowana",
        "dxHtmlEditor-bulletList": "Numerowanie",
        "dxHtmlEditor-alignLeft": "Do lewej",
        "dxHtmlEditor-alignCenter": "Wyśrodkowanie",
        "dxHtmlEditor-alignRight": "Do prawej",
        "dxHtmlEditor-alignJustify": "Wyjustuj",
        "dxHtmlEditor-codeBlock": "Codeblock",
        "dxHtmlEditor-variable": "Dodaj zmienne",
        "dxHtmlEditor-undo": "Wstecz",
        "dxHtmlEditor-redo": "Powtórz",
        "dxHtmlEditor-clear": "Usuń formatowanie",
        "dxHtmlEditor-insertTable": "Wstaw tabelę",
        "dxHtmlEditor-insertHeaderRow": "Dodaj nagłówek",
        "dxHtmlEditor-insertRowAbove": "Wstaw kolumnę powyżej",
        "dxHtmlEditor-insertRowBelow": "Wstaw kolumnę poniżej",
        "dxHtmlEditor-insertColumnLeft": "Wstaw kolumnę po lewej",
        "dxHtmlEditor-insertColumnRight": "Wstaw kolumnę po prawej",
        "dxHtmlEditor-deleteColumn": "Usuń kolumnę",
        "dxHtmlEditor-deleteRow": "Usuń wiersz",
        "dxHtmlEditor-deleteTable": "Usuń tabelę",
        "dxHtmlEditor-cellProperties": "Właściwości komórki",
        "dxHtmlEditor-tableProperties": "Właściwości tabeli",
        "dxHtmlEditor-insert": "Wstaw",
        "dxHtmlEditor-delete": "Usuń",
        "dxHtmlEditor-border": "Ramka",
        "dxHtmlEditor-style": "Styl",
        "dxHtmlEditor-width": "Szerokość",
        "dxHtmlEditor-height": "wysokość",
        "dxHtmlEditor-borderColor": "kolor",
        "dxHtmlEditor-tableBackground": "tło",
        "dxHtmlEditor-dimensions": "wymiary",
        "dxHtmlEditor-alignment": "Orientacja",
        "dxHtmlEditor-horizontal": "poziomo",
        "dxHtmlEditor-vertical": "pionowo",
        "dxHtmlEditor-paddingVertical": "Odstęp w pionie",
        "dxHtmlEditor-paddingHorizontal": "Odstęp w poziomie",
        "dxHtmlEditor-pixels": "Piksel",
        "dxHtmlEditor-list": "Lista",
        "dxHtmlEditor-ordered": "Posortowane",
        "dxHtmlEditor-bullet": "Numerowanie",
        "dxHtmlEditor-align": "Wyrównaj",
        "dxHtmlEditor-center": "Wyśrodkuj",
        "dxHtmlEditor-left": "Po lewej",
        "dxHtmlEditor-right": "Po prawej",
        "dxHtmlEditor-indent": "Wcięcie",
        "dxHtmlEditor-justify": "Wyjustuj",
        "dxHtmlEditor-borderStyleNone": "none",
        "dxHtmlEditor-borderStyleHidden": "hidden",
        "dxHtmlEditor-borderStyleDotted": "dotted",
        "dxHtmlEditor-borderStyleDashed": "dashed",
        "dxHtmlEditor-borderStyleSolid": "solid",
        "dxHtmlEditor-borderStyleDouble": "double",
        "dxHtmlEditor-borderStyleGroove": "groove",
        "dxHtmlEditor-borderStyleRidge": "ridge",
        "dxHtmlEditor-borderStyleInset": "inset",
        "dxHtmlEditor-borderStyleOutset": "outset",

        "dxFileManager-newDirectoryName": "Bez tytułu",
        "dxFileManager-rootDirectoryName": "Pliki",
        "dxFileManager-errorNoAccess": "Odmowa dostępu Nie można wykonać operacji.",
        "dxFileManager-errorDirectoryExistsFormat": "Folder {0} już istnieje.",
        "dxFileManager-errorFileExistsFormat": "Plik {0} już istnieje.",
        "dxFileManager-errorFileNotFoundFormat": "Nie znaleziono pliku {0}.",
        "dxFileManager-errorDirectoryNotFoundFormat": "Nie znaleziono spisu '{0}’.",
        "dxFileManager-errorWrongFileExtension": "Rozszerzenie pliku jest niedozwolone.",
        "dxFileManager-errorMaxFileSizeExceeded": "Rozmiar pliku przekracza maksymalny dozwolony rozmiar.",
        "dxFileManager-errorInvalidSymbols": "Nazwa pliku zawiera niedozwolone znaki.",
        "dxFileManager-errorDefault": "Nieznany błąd",
        "dxFileManager-errorDirectoryOpenFailed": "Nie można otworzyć spisu",

        "dxFileManager-commandCreate": "Nowy spis",
        "dxFileManager-commandRename": "Zmień nazwę",
        "dxFileManager-commandMove": "Przesuń do",
        "dxFileManager-commandCopy": "Kopiuj do",
        "dxFileManager-commandDelete": "Usuń",
        "dxFileManager-commandDownload": "Pobierz",
        "dxFileManager-commandUpload": "Załaduj plik",
        "dxFileManager-commandRefresh": "Aktualizuj",
        "dxFileManager-commandThumbnails": "Miniatury",
        "dxFileManager-commandDetails": "Widok szczegółowy",
        "dxFileManager-commandClearSelection": "Anuluj wybór",
        "dxFileManager-commandShowNavPane": "Włącz/wyłącz obszar nawigacji",

        "dxFileManager-dialogDirectoryChooserMoveTitle": "Przesuń do",
        "dxFileManager-dialogDirectoryChooserMoveButtonText": "Przesuń",
        "dxFileManager-dialogDirectoryChooserCopyTitle": "Kopiuj do",
        "dxFileManager-dialogDirectoryChooserCopyButtonText": "Kopiuj",
        "dxFileManager-dialogRenameItemTitle": "Zmień nazwę",
        "dxFileManager-dialogRenameItemButtonText": "Zapisz",
        "dxFileManager-dialogCreateDirectoryTitle": "Nowy spis",
        "dxFileManager-dialogCreateDirectoryButtonText": "Utwórz",
        "dxFileManager-dialogDeleteItemTitle": "Usuń",
        "dxFileManager-dialogDeleteItemButtonText": "Usuń",
        "dxFileManager-dialogDeleteItemSingleItemConfirmation": "Czy na pewno chcesz usunąć {0}?",
        "dxFileManager-dialogDeleteItemMultipleItemsConfirmation": "Czy na pewno chcesz usunąć te {0} elementy?",
        "dxFileManager-dialogButtonCancel": "Anuluj",

        "dxFileManager-editingCreateSingleItemProcessingMessage": "Spis zostanie utworzony w {0}",
        "dxFileManager-editingCreateSingleItemSuccessMessage": "Utworzono spis w {0}",
        "dxFileManager-editingCreateSingleItemErrorMessage": "Nie utworzono spisu",
        "dxFileManager-editingCreateCommonErrorMessage": "Nie utworzono spisu",

        "dxFileManager-editingRenameSingleItemProcessingMessage": "Nazwa elementu w {0} zostaje zmieniona na",
        "dxFileManager-editingRenameSingleItemSuccessMessage": "Zmieniono nazwę elementu w {0} na",
        "dxFileManager-editingRenameSingleItemErrorMessage": "Nazwa elementu nie została zmieniona",
        "dxFileManager-editingRenameCommonErrorMessage": "Nazwa elementu nie została zmieniona",

        "dxFileManager-editingDeleteSingleItemProcessingMessage": "Element z {0} jest usuwany",
        "dxFileManager-editingDeleteMultipleItemsProcessingMessage": "{0} Elementy z {1} są usuwane",
        "dxFileManager-editingDeleteSingleItemSuccessMessage": "Element z {0} został usunięty",
        "dxFileManager-editingDeleteMultipleItemsSuccessMessage": "{0} Elementy z {1} zostały usunięte",
        "dxFileManager-editingDeleteSingleItemErrorMessage": "Element nie został usunięty",
        "dxFileManager-editingDeleteMultipleItemsErrorMessage": "{0} Elementy nie zostały usunięte",
        "dxFileManager-editingDeleteCommonErrorMessage": "Niektóre elementy nie zostały usunięte",

        "dxFileManager-editingMoveSingleItemProcessingMessage": "Element zostanie przesunięty do {0}",
        "dxFileManager-editingMoveMultipleItemsProcessingMessage": "{0} Elementy zostaną przesunięte do {1}",
        "dxFileManager-editingMoveSingleItemSuccessMessage": "Element został przesunięty do {0}",
        "dxFileManager-editingMoveMultipleItemsSuccessMessage": "{0} Elementy zostały przesunięte do {1}",
        "dxFileManager-editingMoveSingleItemErrorMessage": "Element nie został przesunięty",
        "dxFileManager-editingMoveMultipleItemsErrorMessage": "{0} Elementy nie zostały przesunięte",
        "dxFileManager-editingMoveCommonErrorMessage": "Niektóre elementy nie zostały przesunięte",

        "dxFileManager-editingCopySingleItemProcessingMessage": "Element zostanie skopiowany do {0}",
        "dxFileManager-editingCopyMultipleItemsProcessingMessage": "{0} Elementy zostaną skopiowane do {1}",
        "dxFileManager-editingCopySingleItemSuccessMessage": "Element został skopiowany do {0}",
        "dxFileManager-editingCopyMultipleItemsSuccessMessage": "{0} Elementy zostały skopiowane do {1}",
        "dxFileManager-editingCopySingleItemErrorMessage": "Element nie został skopiowany",
        "dxFileManager-editingCopyMultipleItemsErrorMessage": "{0} Elementy nie zostały skopiowane",
        "dxFileManager-editingCopyCommonErrorMessage": "Niektóre elementy nie zostały skopiowane",

        "dxFileManager-editingUploadSingleItemProcessingMessage": "Element zostanie załadowany do {0}",
        "dxFileManager-editingUploadMultipleItemsProcessingMessage": "{0} Elementy zostaną załadowane do {1}",
        "dxFileManager-editingUploadSingleItemSuccessMessage": "Element został załadowany do {0}",
        "dxFileManager-editingUploadMultipleItemsSuccessMessage": "{0} Elementy zostały załadowane do {1}",
        "dxFileManager-editingUploadSingleItemErrorMessage": "Element nie został załadowany",
        "dxFileManager-editingUploadMultipleItemsErrorMessage": "{0} Elementy nie zostały załadowane",
        "dxFileManager-editingUploadCanceledMessage": "Anulowano",

        "dxFileManager-editingDownloadSingleItemErrorMessage": "Plik nie został załadowany",
        "dxFileManager-editingDownloadMultipleItemsErrorMessage": "{0} Pliki nie zostały załadowane",

        "dxFileManager-listDetailsColumnCaptionName": "Nazwisko",
        "dxFileManager-listDetailsColumnCaptionDateModified": "Ostatnio zmieniono dnia",
        "dxFileManager-listDetailsColumnCaptionFileSize": "Rozmiar pliku",

        "dxFileManager-listThumbnailsTooltipTextSize": "Rozmiar",
        "dxFileManager-listThumbnailsTooltipTextDateModified": "Ostatnio zmieniono dnia",

        "dxFileManager-notificationProgressPanelTitle": "Postęp",
        "dxFileManager-notificationProgressPanelEmptyListText": "Brak procesów",
        "dxFileManager-notificationProgressPanelOperationCanceled": "Anulowano",

        "dxDiagram-categoryGeneral": "Ogólne",
        "dxDiagram-categoryFlowchart": "Diagram przepływu",
        "dxDiagram-categoryOrgChart": "Schemat organizacyjny",
        "dxDiagram-categoryContainers": "Kontener",
        "dxDiagram-categoryCustom": "Spersonalizowany",

        "dxDiagram-commandExportToSvg": "Eksport jako SVG",
        "dxDiagram-commandExportToPng": "Eksport jako PNG",
        "dxDiagram-commandExportToJpg": "Eksport jako JPEG",
        "dxDiagram-commandUndo": "Wstecz",
        "dxDiagram-commandRedo": "Przywróć",
        "dxDiagram-commandFontName": "Nazwa czcionki",
        "dxDiagram-commandFontSize": "Rozmiar czcionki",
        "dxDiagram-commandBold": "Wytłuszczenie",
        "dxDiagram-commandItalic": "Kurysywa",
        "dxDiagram-commandUnderline": "Podkreślenie",
        "dxDiagram-commandTextColor": "Kolor tekstu",
        "dxDiagram-commandLineColor": "Kolor linii",
        "dxDiagram-commandLineWidth": "Grubość linii",
        "dxDiagram-commandLineStyle": "Rodzaj linii",
        "dxDiagram-commandLineStyleSolid": "Ciągła",
        "dxDiagram-commandLineStyleDotted": "Wykropkowana",
        "dxDiagram-commandLineStyleDashed": "Kreskowa",
        "dxDiagram-commandFillColor": "Kolor wypełnienia",
        "dxDiagram-commandAlignLeft": "Do lewej",
        "dxDiagram-commandAlignCenter": "Wyśrodkowanie",
        "dxDiagram-commandAlignRight": "Do prawej",
        "dxDiagram-commandConnectorLineType": "Łącznik typu linii",
        "dxDiagram-commandConnectorLineStraight": "Prosty",
        "dxDiagram-commandConnectorLineOrthogonal": "Prostokątny",
        "dxDiagram-commandConnectorLineStart": "Łącznik początku linii",
        "dxDiagram-commandConnectorLineEnd": "Łącznik końca linii",
        "dxDiagram-commandConnectorLineNone": "Brak",
        "dxDiagram-commandConnectorLineArrow": "Strzałka",
        "dxDiagram-commandFullscreen": "Pełny ekran",
        "dxDiagram-commandUnits": "Jednostki",
        "dxDiagram-commandPageSize": "Rozmiar strony",
        "dxDiagram-commandPageOrientation": "Orientacja strony",
        "dxDiagram-commandPageOrientationLandscape": "Format poziomy",
        "dxDiagram-commandPageOrientationPortrait": "Format pionowy",
        "dxDiagram-commandPageColor": "Kolor strony",
        "dxDiagram-commandShowGrid": "Wyświetl raster",
        "dxDiagram-commandSnapToGrid": "Wyrównaj według rastra",
        "dxDiagram-commandGridSize": "Rozmiar rastra",
        "dxDiagram-commandZoomLevel": "Stopień powiększenia",
        "dxDiagram-commandAutoZoom": "Automatyczne powiększenie",
        "dxDiagram-commandFitToContent": "Dostosuj do zawartości",
        "dxDiagram-commandFitToWidth": "Dostosuj do szerokości",
        "dxDiagram-commandAutoZoomByContent": "Automatycznie dostosuj do zawartości",
        "dxDiagram-commandAutoZoomByWidth": "Automatycznie dostosuj do szerokości",
        "dxDiagram-commandSimpleView": "Widok zwykły",
        "dxDiagram-commandCut": "Wytnij",
        "dxDiagram-commandCopy": "Kopiuj",
        "dxDiagram-commandPaste": "Wstaw",
        "dxDiagram-commandSelectAll": "Wybierz wszystko",
        "dxDiagram-commandDelete": "Usuń",
        "dxDiagram-commandBringToFront": "Do przodu",
        "dxDiagram-commandSendToBack": "Do tyłu",
        "dxDiagram-commandLock": "Zablokuj",
        "dxDiagram-commandUnlock": "Odblokuj",
        "dxDiagram-commandInsertShapeImage": "Wstaw obraz...",
        "dxDiagram-commandEditShapeImage": "Edytuj obraz...",
        "dxDiagram-commandDeleteShapeImage": "Usuń obraz",
        "dxDiagram-commandLayoutLeftToRight": "Od lewej do prawej",
        "dxDiagram-commandLayoutRightToLeft": "Od prawej do lewej",
        "dxDiagram-commandLayoutTopToBottom": "Z góry na dół",
        "dxDiagram-commandLayoutBottomToTop": "Z dołu do góry",

        "dxDiagram-unitIn": "w/do",
        "dxDiagram-unitCm": "cm",
        "dxDiagram-unitPx": "px",

        "dxDiagram-dialogButtonOK": "OK",
        "dxDiagram-dialogButtonCancel": "Anuluj",
        "dxDiagram-dialogInsertShapeImageTitle": "Wstaw obraz",
        "dxDiagram-dialogEditShapeImageTitle": "Edytuj obraz",
        "dxDiagram-dialogEditShapeImageSelectButton": "Wybierz obraz",
        "dxDiagram-dialogEditShapeImageLabelText": "lub umieść plik tutaj",

        "dxDiagram-uiExport": "Eksport",
        "dxDiagram-uiProperties": "Właściwości",
        "dxDiagram-uiSettings": "Ustawienia",
        "dxDiagram-uiShowToolbox": "Pokaż przybornik",
        "dxDiagram-uiSearch": "Szukaj",
        "dxDiagram-uiStyle": "Styl",
        "dxDiagram-uiLayout": "Layout",
        "dxDiagram-uiLayoutTree": "Drzewo",
        "dxDiagram-uiLayoutLayered": "Wielowarstwowy",
        "dxDiagram-uiDiagram": "Diagram",
        "dxDiagram-uiText": "Tekst",
        "dxDiagram-uiObject": "Obiekt",
        "dxDiagram-uiConnector": "Powiązanie",
        "dxDiagram-uiPage": "Strona",

        "dxDiagram-shapeText": "Tekst",
        "dxDiagram-shapeRectangle": "Prostokąt",
        "dxDiagram-shapeEllipse": "Elipsa",
        "dxDiagram-shapeCross": "Krzyż",
        "dxDiagram-shapeTriangle": "Trójkąt",
        "dxDiagram-shapeDiamond": "Romb",
        "dxDiagram-shapeHeart": "Serce",
        "dxDiagram-shapePentagon": "Pięciokąt",
        "dxDiagram-shapeHexagon": "Sześciokąt",
        "dxDiagram-shapeOctagon": "Ośmiokąt",
        "dxDiagram-shapeStar": "Gwiazda",
        "dxDiagram-shapeArrowLeft": "Strzałka w lewo",
        "dxDiagram-shapeArrowUp": "Strzałka w górę",
        "dxDiagram-shapeArrowRight": "Strzałka w prawo",
        "dxDiagram-shapeArrowDown": "Strzałka w dół",
        "dxDiagram-shapeArrowUpDown": "Strzałka w górę i w dół",
        "dxDiagram-shapeArrowLeftRight": "Strzałka w lewo i w prawo",
        "dxDiagram-shapeProcess": "Proces",
        "dxDiagram-shapeDecision": "Decyzja",
        "dxDiagram-shapeTerminator": "Zakończenie",
        "dxDiagram-shapePredefinedProcess": "Predefiniowany proces",
        "dxDiagram-shapeDocument": "Dokument",
        "dxDiagram-shapeMultipleDocuments": "Wiele dokumentów",
        "dxDiagram-shapeManualInput": "Wprowadzanie ręczne",
        "dxDiagram-shapePreparation": "Przygotowanie",
        "dxDiagram-shapeData": "Dane",
        "dxDiagram-shapeDatabase": "Baza danych",
        "dxDiagram-shapeHardDisk": "Dysk twardy",
        "dxDiagram-shapeInternalStorage": "Pamięć lokalna",
        "dxDiagram-shapePaperTape": "Taśma dziurkowana",
        "dxDiagram-shapeManualOperation": "Przetwarzanie ręczne",
        "dxDiagram-shapeDelay": "Zwłoka",
        "dxDiagram-shapeStoredData": "Zapisane dane",
        "dxDiagram-shapeDisplay": "Wyświetlanie",
        "dxDiagram-shapeMerge": "Połącz",
        "dxDiagram-shapeConnector": "Łącznik",
        "dxDiagram-shapeOr": "lub",
        "dxDiagram-shapeSummingJunction": "Węzeł sumowania",
        "dxDiagram-shapeContainerDefaultText": "Kontener",
        "dxDiagram-shapeVerticalContainer": "Kontener pionowy",
        "dxDiagram-shapeHorizontalContainer": "Kontener poziomy",
        "dxDiagram-shapeCardDefaultText": "Nazwisko osoby",
        "dxDiagram-shapeCardWithImageOnLeft": "Karta z obrazkiem po lewej stronie",
        "dxDiagram-shapeCardWithImageOnTop": "Karta z obrazkiem na górze",
        "dxDiagram-shapeCardWithImageOnRight": "Karta z obrazkiem po prawej stronie",

        "dxGantt-dialogTitle": "Tytuł",
        "dxGantt-dialogStartTitle": "Początek",
        "dxGantt-dialogEndTitle": "Koniec",
        "dxGantt-dialogProgressTitle": "Postęp",
        "dxGantt-dialogResourcesTitle": "Zasoby",
        "dxGantt-dialogResourceManagerTitle": "Menedżer zasobów",
        "dxGantt-dialogTaskDetailsTitle": "Szczegóły zadania",
        "dxGantt-dialogEditResourceListHint": "Edytuj listę zasobów",
        "dxGantt-dialogEditNoResources": "Brak zasobów",
        "dxGantt-dialogButtonAdd": "Dodaj",
        "dxGantt-contextMenuNewTask": "Nowe zadanie",
        "dxGantt-contextMenuNewSubtask": "Nowe zadanie cząstkowe",
        "dxGantt-contextMenuDeleteTask": "Usuń zadanie",
        "dxGantt-contextMenuDeleteDependency": "Usuń zależności",
        "dxGantt-dialogTaskDeleteConfirmation": "Zależności i zadania cząstkowe zostaną usunięte razem z tym zadaniem. Czy chcesz usunąć to zadanie?",
        "dxGantt-dialogDependencyDeleteConfirmation": "Czy chcesz usunąć zależność z zadania?",
        "dxGantt-dialogResourcesDeleteConfirmation": "Jeśli usuniesz ten zasób, zostanie on usunięty ze wszystkich zadań. Czy chcesz usunąć zasób? Zasób: {0}",
        "dxGantt-dialogConstraintCriticalViolationMessage": "Zadanie, które chcesz przesunąć, jest połączone z innym zadaniem zależnością. Zmiana ta naruszyłaby reguły zależności. Jak chcesz postąpić?",
        "dxGantt-dialogConstraintViolationMessage": "Zadanie, które chcesz przesunąć, jest połączone z innym zadaniem zależnością. Jak chcesz postąpić?",
        "dxGantt-dialogCancelOperationMessage": "Anuluj działanie",
        "dxGantt-dialogDeleteDependencyMessage": "Usuń zależność",
        "dxGantt-dialogMoveTaskAndKeepDependencyMessage": "Przenieś zadanie i zachowaj zależność",
        "dxGantt-dialogConstraintCriticalViolationSeveralTasksMessage": "Zadanie, które próbujesz przesunąć, jest powiązane z innymi zadaniami poprzez relacje zależności. Zmiana narusza zatem zasady zależności. Jak chcesz postąpić?",
        "dxGantt-dialogConstraintViolationSeveralTasksMessage": "Zadanie, które próbujesz przesunąć, jest powiązane z innymi zadaniami poprzez relacje zależności. Jak chcesz postąpić?",
        "dxGantt-dialogDeleteDependenciesMessage": "Usuń relacje zależności",
        "dxGantt-dialogMoveTaskAndKeepDependenciesMessage": "Przesuń zadanie i zachowaj relacje zależności.",
        "dxGantt-undo": "Wstecz",
        "dxGantt-redo": "Przywróć",
        "dxGantt-expandAll": "Rozwiń wszystko",
        "dxGantt-collapseAll": "Zwiń wszystko",
        "dxGantt-addNewTask": "Dodaj nowe zadanie",
        "dxGantt-deleteSelectedTask": "Usuń wybrane zadanie",
        "dxGantt-zoomIn": "Powiększ",
        "dxGantt-zoomOut": "Zmniejsz",
        "dxGantt-fullScreen": "Tryb pełnego ekranu",
        "dxGantt-quarter": "Q{0}",
        "dxGantt-sortingAscendingText": "Sortuj rosnąco",
        "dxGantt-sortingDescendingText": "Sortuj malejąco",
        "dxGantt-sortingClearText": "Resetuj sortowanie",
        "dxGantt-showResources": "Wyświetl zasoby",
        "dxGantt-showDependencies": "Wyświetl zależności",
        "dxGantt-dialogStartDateValidation": "Data rozpoczęcia musi być późniejsza niż {0}",
        "dxGantt-dialogEndDateValidation": "Data zakończenia musi być późniejsza niż {0}",

        "dxGallery-itemName": "Gallery item",

        "dxMultiView-elementAriaRoleDescription": "MultiView",
        "dxMultiView-elementAriaLabel": "Use the arrow keys or swipe to navigate between views",
        "dxMultiView-itemAriaRoleDescription": "View",
        "dxMultiView-itemAriaLabel": "{0} of {1}",

        "dxSplitter-resizeHandleAriaLabel": "Split bar"
    }
}
